/* eslint-disable */
import Cookies from 'js-cookie'
import IviewLangs from './iviewLangs'

// 语言包列表, 合并语言包
// const locales = {
//   'cn': Object.assign(require('../lang/cn'), IviewLangs.zh_CN),
//   'en': Object.assign(require('../lang/en'), IviewLangs.en_US),
//   'es': Object.assign(require('../lang/es'), IviewLangs.es_ES),
//   'pl': Object.assign(require('../lang/pl'), IviewLangs.pl_PL)
// }

// 从static引入语言包
const lang_cn = cn
const lang_en = en
const lang_es = es
const lang_pl = pl
const lang_tw = tw
const lang_pt = pt

// 合并语言包
const locales = {
  'cn': Object.assign(lang_cn, IviewLangs.zh_CN),
  'en': Object.assign(lang_en, IviewLangs.en_US),
  'es': Object.assign(lang_es, IviewLangs.es_ES),
  'pl': Object.assign(lang_pl, IviewLangs.pl_PL),
  'tw': Object.assign(lang_tw, IviewLangs.zh_TW),
  'pt': Object.assign(lang_pt, IviewLangs.pt_PT)
}

const LOCALE_KEY = 'localeLanguage'

let lang
const setup = () => {
  if (lang === undefined) {
    // 先从cookies中获取语言参数
    lang = Cookies.get(LOCALE_KEY)
    if (locales[lang] === undefined) {
      // 再跟据浏览器语言获取语言参数
      if (navigator.userAgent.indexOf('MSIE') >= 0) {
        lang = navigator.browserLanguage
      } else if (navigator.userAgent.indexOf('Firefox') >= 0 || navigator.userAgent.indexOf('Chrome') >= 0 ||
        navigator.userAgent.indexOf('Opera') >= 0 || navigator.userAgent.indexOf('Mozilla') >= 0) {
        lang = navigator.language
      } else {
        lang = navigator.language
      }
    }
    if (lang.indexOf('CN') > -1 || lang.indexOf('cn') > -1 || lang.indexOf('ZH') > -1 || lang.indexOf('zh') > -1) {
      lang = 'cn'
    } else if (lang.indexOf('en') > -1) {
      lang = 'en'
    } else if (lang.indexOf('TW') > -1 || lang.indexOf('tw') > -1) {
      lang = 'tw'
    } else if (lang.indexOf('TR') > -1 || lang.indexOf('tr') > -1) {
      lang = 'tr'
    } else if (lang.indexOf('TH') > -1 || lang.indexOf('th') > -1) {
      lang = 'th'
    } else if (lang.indexOf('PT') > -1 || lang.indexOf('pt') > -1) {
      lang = 'pt'
    } else if (lang.indexOf('AR') > -1 || lang.indexOf('ar') > -1) {
      lang = 'ar'
    } else if (lang.indexOf('ES') > -1 || lang.indexOf('es') > -1) {
      lang = 'es'
    } else if (lang.indexOf('BG') > -1 || lang.indexOf('bg') > -1) {
      lang = 'bg'
    } else if (lang.indexOf('RU') > -1 || lang.indexOf('ru') > -1) {
      lang = 'ru'
    } else if (lang.indexOf('PL') > -1 || lang.indexOf('pl') > -1) {
      lang = 'pl'
    } else {
      lang = 'en'
    }
  }
  Cookies.set(LOCALE_KEY, lang)
  Object.keys(locales).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)
  return lang
}

export default {
  DEFAULT_LANG: setup(),
  LOCALES: locales
}



// WEBPACK FOOTER //
// ./src/common/lang/config.js